import { keyIsPrintable, isDeleteChar } from '../utils/parse.js';

let acKeyCount = 0;
let acDelCount = 0;

function logAutocompleteUsage() {
    document.getElementById('keywordTextbox')?.addEventListener("keydown", function (e) {
        // If printable character is pressed
        if (keyIsPrintable(e)) {
            acKeyCount += 1;
        }
        // If backspace/delete is pressed
        if (isDeleteChar(e) && (acKeyCount > 0)) {
            acDelCount += 1;
        }
    });
}

function clearAutocompleteUsage() {
    acKeyCount = 0;
    acDelCount = 0;
}

function getAutocompleteMetrics(autocompletePrefix) {
    autocompletePrefix = (typeof autocompletePrefix === "string" && autocompletePrefix.length > 0) ? autocompletePrefix : null;
    return {
        autocompletePrefix: autocompletePrefix,
        autocompleteKeyCount: acKeyCount,
        autocompleteBackspaceCount: acDelCount
    };
}

export { logAutocompleteUsage, clearAutocompleteUsage, getAutocompleteMetrics };